import Page from 'shared/types/Page'
import ViewSections from 'pages/ViewSections'
import AddPage from 'pages/AddPage'
import AddSection from 'pages/AddSection'
import AddCustomer from 'pages/AddCustomer'
import Customers from 'pages/Customers'
import Filters from 'pages/Filters'
import AddFilter from 'pages/AddFilter'
import Users from 'pages/Users'
import ViewPages from 'pages/Pages'
import Permissions from 'pages/Permissions'
import Reports from 'pages/Reports'
import AddPermission from 'pages/AddPermission'
import AddReport from 'pages/AddReport'
import EmailTemplates from 'pages/EmailTemplates'
import AddUser from 'pages/AddUser'
import ImportFilterValues from 'pages/ImportFilterValues'
import { roles } from 'consts'
import Settings from 'pages/Settings'
import Roles from 'pages/Roles'
import AddRole from 'pages/AddRole'
import UserPasswordChange from 'pages/UserChangePassword'
import EditEmailTemplate from 'pages/EditEmailTemplate'
import UserAccount from 'pages/UserAccount'
import SupportForm from 'pages/SupportForm'
import ImportPermissions from 'pages/ImportPermissions'
import ImportPermissionsToFilterValues from 'pages/ImportPermissionsToFilterValues'
import AddConnection from 'pages/AddConnection'
import Connections from 'pages/Connections'
import FilterValuesNotification from 'pages/FilterValuesNotification'
import ChangeConnectionPassword from 'pages/ChangeConnectionPassword'
import FilterSyncLog from 'pages/FilterSyncLog'
import FilterSyncLogDetails from 'pages/FilterSyncLogDetails'

let Pages: Page[] = []

Pages = [
  {
    name: 'Sections',
    component: ViewSections,
    path: '/sections',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'gridOutline',
  },
  {
    name: 'Add Section',
    component: AddSection,
    parentPath: '/sections',
    path: '/add-section',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Section',
    component: AddSection,
    parentPath: '/sections',
    path: '/edit-section/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Pages',
    component: ViewPages,
    path: '/pages',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'browsersOutline',
  },
  {
    name: 'Add Page',
    component: AddPage,
    parentPath: '/pages',
    path: '/add-page',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Page',
    component: AddPage,
    parentPath: '/pages',
    path: '/edit-page/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Reports',
    component: Reports,
    path: '/reports',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'trendingUp',
  },
  {
    name: 'Add Report',
    component: AddReport,
    parentPath: '/reports',
    path: '/add-report',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Report',
    component: AddReport,
    parentPath: '/reports',
    path: '/edit-report/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Filters',
    component: Filters,
    path: '/filters',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'funnelOutline',
  },
  {
    name: 'Add Filter',
    component: AddFilter,
    parentPath: '/filters',
    path: '/add-filter',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Sync Log',
    component: FilterSyncLog,
    parentPath: '/filters',
    path: '/filter-sync-log/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Sync Log Details',
    component: FilterSyncLogDetails,
    parentPath: '/filters',
    path: '/filter-sync-log-details/:id/:filterId',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Filter',
    component: AddFilter,
    parentPath: '/filters',
    path: '/edit-filter/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Import Filter Values',
    component: ImportFilterValues,
    path: '/import-filter-values',
    parentPath: '/filters',
    roles: [roles.superAdmin],
    showInMenu: false,
  },
  {
    name: 'Users',
    component: Users,
    path: '/users',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'peopleOutline',
  },
  {
    name: 'Change Password',
    component: UserPasswordChange,
    path: '/change-password/:id',
    parentPath: '/users',
    showInMenu: false,
  },
  {
    name: 'Add User',
    component: AddUser,
    parentPath: '/users',
    path: '/add-user',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit User',
    component: AddUser,
    parentPath: '/users',
    path: '/edit-user/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Permissions',
    component: Permissions,
    path: '/permissions',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'keyOutline',
  },
  {
    name: 'Import Permissions',
    component: ImportPermissions,
    path: '/import-permissions',
    parentPath: '/permissions',
    roles: [roles.superAdmin],
    showInMenu: false,
  },
  {
    name: 'Import Permission to Filter Values ',
    component: ImportPermissionsToFilterValues,
    parentPath: '/edit-permission/:id',
    path: '/import-permission-to-filter-values/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Permission',
    component: AddPermission,
    parentPath: '/permissions',
    path: '/edit-permission/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Roles',
    component: Roles,
    path: '/roles',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'personCircleOutline',
  },
  {
    name: 'Add Role',
    component: AddRole,
    parentPath: '/roles',
    path: '/add-role',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Role',
    component: AddRole,
    parentPath: '/roles',
    path: '/edit-role/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Customers',
    component: Customers,
    path: '/customers',
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'homeOutline',
  },
  {
    name: 'Add Customer',
    component: AddCustomer,
    parentPath: '/customers',
    path: '/add-customer',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Customer',
    component: AddCustomer,
    parentPath: '/customers',
    path: '/edit-customer/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Settings',
    path: false,
    isDropdown: true,
    showInMenu: 'left',
    roles: [roles.superAdmin],
    icon: 'settingsOutline',
  },
  {
    name: 'General Settings',
    component: Settings,
    path: '/general-settings',
    showInMenu: 'left',
    parentPath: '#Settings',
    dropdownName: 'Settings',
    roles: [roles.superAdmin],
  },
  {
    name: 'Connections',
    component: Connections,
    path: '/connections',
    showInMenu: 'left',
    parentPath: '#Settings',
    dropdownName: 'Settings',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Connection',
    component: AddConnection,
    parentPath: '/connections',
    path: '/add-connection',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Connection',
    component: AddConnection,
    parentPath: '/connections',
    path: '/edit-connection/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
  name: 'Change Connection Password',
  component: ChangeConnectionPassword,
  path: '/change-connection-password/:id',
  parentPath: '/connections',
  showInMenu: false,
},
  {
    name: 'Email Templates',
    component: EmailTemplates,
    path: '/email-templates',
    showInMenu: 'left',
    parentPath: '#Settings',
    dropdownName: 'Settings',
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Email Template',
    component: EditEmailTemplate,
    path: '/edit-email-template/:id',
    showInMenu: false,
    parentPath: '/email-templates',
    roles: [roles.superAdmin],
  },
  {
    name: 'Filter Values Notification',
    component: FilterValuesNotification,
    path: '/filter-values-notification',
    showInMenu: 'left',
    parentPath: '#Settings',
    dropdownName: 'Settings',
    roles: [roles.superAdmin],
  },
  {
    name: 'Profile',
    component: Settings,
    path: false,
    showInMenu: 'top',
    isDropdown: true,
    roles: [roles.user],
  },
  {
    name: 'User Account',
    component: UserAccount,
    path: '/user-account',
    showInMenu: 'top',
    parentPath: '#Profile',
    dropdownName: 'Profile',
    roles: [roles.user],
  },
  {
    name: 'Support Form',
    component: SupportForm,
    path: '/support-form',
    showInMenu: 'top',
    parentPath: '#Profile',
    dropdownName: 'Profile',
    roles: [roles.user],
  },
]

export default Pages
